export type { TableHeaderProps, TableHeaderSlots, TableHeaderState } from './components/TableHeader/index';
export {
  TableHeader,
  renderTableHeader_unstable,
  tableHeaderClassName,
  tableHeaderClassNames,
  useTableHeaderStyles_unstable,
  useTableHeader_unstable,
} from './components/TableHeader/index';
